import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Dropdown = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fill={color}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 5H11C12.6569 5 14 6.34315 14 8C14 9.65685 12.6569 11 11 11H5C3.34315 11 2 9.65685 2 8C2 6.34315 3.34315 5 5 5ZM1 8C1 5.79086 2.79086 4 5 4H11C13.2091 4 15 5.79086 15 8C15 10.2091 13.2091 12 11 12H5C2.79086 12 1 10.2091 1 8ZM9.35355 7.14645C9.15829 6.95118 8.84171 6.95118 8.64645 7.14645C8.45118 7.34171 8.45118 7.65829 8.64645 7.85355L10.1464 9.35355C10.3417 9.54882 10.6583 9.54882 10.8536 9.35355L12.3536 7.85355C12.5488 7.65829 12.5488 7.34171 12.3536 7.14645C12.1583 6.95118 11.8417 6.95118 11.6464 7.14645L10.5 8.29289L9.35355 7.14645Z"
      />
    </svg>
  )
})

export default Dropdown
